import { render } from "./ProviderHeader.vue?vue&type=template&id=098d8e91&scoped=true"
const script = {}

import "./ProviderHeader.vue?vue&type=style&index=0&id=098d8e91&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098d8e91"]])

export default __exports__